<template>
  <div id="logged-out-wrap" :style="styles.wrap(ready)">
    <section class="bg-banner">
      <img
        src="http://gigeconomygroup.com/wp-content/uploads/2018/03/gig-economy-incorrect-logo-02.svg"
        class="logo-img"
      >
      <p>Sales Enablement.
        <br>
        <strong>Informed by Human Intelligence.</strong>
        <br>Powered By Machine Learning.
      </p>
      <span>v{{ version }}</span>
    </section>
    <section>
      <transition name="slide-fade">
        <div class="loading" v-if="loading"></div>
      </transition>

      <transition name="slide-fade">
        <router-view v-if="!loading"></router-view>
      </transition>
    </section>
  </div>
</template>

<script>
import store from '../../store.js';
import { getResource } from '../../services/Utils.js';
import PackageData from '../../../package.json';
export default {
  name: 'top',
  computed: {
    version() {
      return PackageData.version;
    }
  },
  data() {
    return {
      loading: false,
      ready: false,
      styles: {
        wrap: r => ({
          opacity: r ? '1' : '0',
          transition: 'opacity 1500ms ease-out'
        })
      }
    };
  },
  methods: {
    getDomain(domain) {
      return new Promise((resolve, reject) => {
        getResource('/v1/tenants/domain')
          .then(res => {
            console.log(res);
            console.log(res);
            store.commit('setDomain', domain);
            if (res.status === 'success') {
              store.commit('setTenant', res.tenant);
              return resolve();
            }
            store.commit('setTenant', false);
            return reject(res);
          })
          .catch(err => {
            console.log(err);
            store.commit('setTenant', false);
            return reject(err);
          });
      });
    }
  },
  mounted() {
    console.log(store.getters.getTenant);
    if (!store.getters.getTenant._id) {
      const str = window.location.host;
      const domain = str.split('.')[0];
      this.getDomain(domain)
        .then(() => {
          console.log(store.getters.getTenant._id);
          window.Intercom("boot", {
            app_id: "kkkzq24u"
          });
        })
        .catch(error => console.log(error));
    }
    setTimeout(() => {
      this.ready = true;
    }, 500);

    store.commit('setUser', {});
    store.commit('setCards', []);
    store.commit('setCardTypes', []);
    store.commit('setActiveCard', {});
    store.commit('setActiveLocalRecord', {});
    store.commit('setActiveLocalRecordSaved', []);
    store.commit('setMedia', []);
    store.commit('setActiveMedia', {});
    store.commit('setAllProducts', []);
    store.commit('setActiveProducts', {});
    store.commit('setAllProductGroups', []);
    store.commit('setAllMediaLibraries', []);
    store.commit('setActiveMediaLibrary', {})
    store.commit('setMediaTabs', []);
    store.commit('setMediaActiveTab', {})
    store.commit('setPolicies', [])
    store.commit('setActivePolicy', {});
    store.commit('setInteractionTypes', []);
    store.commit('setSelectedSequence', {})
    store.commit('setMarkets', []);
    store.commit('setActiveMarket', {});
    store.commit('setSequences', []);
    store.commit('setActiveSequence', {})
    store.commit('setSequenceCards', []);
    store.commit('setProducts', []);
    store.commit('setActiveProduct', {});
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  overflow: hidden;
}
#logged-out-wrap {
  display: flex;
  flex-flow: row nowrap;
}

.bg-banner {
  width: 40vw;
  height: 100vh;
  background: linear-gradient(to bottom, rgb(0, 168, 224), rgb(28, 168, 140));
  background: -moz-linear-gradient(
    to bottom,
    rgb(0, 168, 224),
    rgb(28, 168, 140)
  );
  background: -webkit-linear-gradient(
    to bottom,
    rgb(0, 168, 224),
    rgb(28, 168, 140)
  );
  display: flex;
  flex-flow: column nowrap;
}

.bg-banner .logo-img {
  max-width: 40%;
  margin: 10px;
}

.bg-banner p {
  margin: auto;
  text-align: center;
  font-size: 1.5em;
  font-weight: 300;
  line-height: 1.5;
  color: #fff;
  padding: 20px;
  max-width: 100%;
}

.bg-banner p strong {
  font-weight: 700;
}

.bg-banner span {
  padding: 10px;
  color: #ccc;
  font-size: 1em;
  display: block;
  text-align: right;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 1.5s ease;
  position: relative;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
  left: 10px;
  opacity: 0;
}

/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: '';
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1500ms infinite linear;
  -moz-animation: spinner 1500ms infinite linear;
  -ms-animation: spinner 1500ms infinite linear;
  -o-animation: spinner 1500ms infinite linear;
  animation: spinner 1500ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0,
    rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0,
    rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0,
    rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/LoggedOut.vue